module.exports = __webpack_public_path__ + "img/youhuiquan.9b8cea8d.png";